import { t } from '@trimble/i18n';
import { Component } from 'solid-js';
import { ButtonGroup } from '@trimble/ui-components/solidjs';
import type { ButtonGroupOption } from '@trimble/ui-components/solidjs';
import type {
  AlignmentMeasurementController,
  AlignmentMode,
} from './alignment-measurement.types';

export interface AlignmentMeasurementOptionsProps {
  controller: AlignmentMeasurementController;
}

export const AlignmentMeasurementOptions: Component<
  AlignmentMeasurementOptionsProps
> = (props) => {
  const modeOptions: ButtonGroupOption<AlignmentMode>[] = [
    {
      value: 'perpendicular',
      label: t('measurements.alignment.perpendicular'),
    },
    { value: 'vertical', label: t('measurements.alignment.vertical') },
  ];

  return (
    <div class="flex flex-col gap-3 px-4 pb-2">
      <div class="flex flex-col gap-1" data-testid="cant-mode-section">
        <span class="text-sm text-gray-8">
          {t('measurements.alignment.cant')}
        </span>
        <ButtonGroup
          options={modeOptions}
          value={props.controller.cantMode()}
          disabled={true}
          onChange={(value) =>
            props.controller.setCantMode(value as AlignmentMode)
          }
          testId="cant-mode"
        />
      </div>
      <div class="flex flex-col gap-1" data-testid="gradient-mode-section">
        <span class="text-sm text-gray-8">
          {t('measurements.alignment.gradient')}
        </span>
        <ButtonGroup
          options={modeOptions}
          value={props.controller.gradientMode()}
          disabled={true}
          onChange={(value) =>
            props.controller.setGradientMode(value as AlignmentMode)
          }
          testId="gradient-mode"
        />
      </div>
    </div>
  );
};
